import { resolveModuleTypeIcon } from "@frontend/pages/case-workspace/components/module-type-icon"
import type {
  AnnotationTimeSchema,
  ImageLabelSchema,
  MaskSchema,
  ParsedModuleSchema,
  PiqualSchema,
  PiradsSchema,
  ScoreSchema,
  Submission,
  TextSchema,
  VectorSchema
} from "@frontend/pages/case-workspace/radiology/types"
import { Layers } from "lucide-react"
import type React from "react"

export function parseModuleSchema(raw: string): ParsedModuleSchema {
  try {
    const obj = JSON.parse(raw) as { type?: string }
    if (obj?.type === "mask") return obj as MaskSchema
    if (obj?.type === "score") return obj as ScoreSchema
    if (obj?.type === "vector") return obj as VectorSchema
    if (obj?.type === "image_label") return obj as ImageLabelSchema
    if (obj?.type === "text") return obj as TextSchema
    if (obj?.type === "piqual") return obj as PiqualSchema
    if (obj?.type === "pirads") return obj as PiradsSchema
    if (obj?.type === "annotation_time") return obj as AnnotationTimeSchema
    return null
  } catch {
    return null
  }
}

export function moduleTypeIcon(type: string): React.ReactElement {
  return resolveModuleTypeIcon(type, {
    mask: <Layers className="size-3.5 shrink-0 text-muted-foreground" />
  })
}

export function sortCandidateSubmissions(items: Submission[]): Submission[] {
  const rank = (status: string) => {
    if (status === "in_progress") return 0
    if (status === "revision_needed") return 1
    return 2
  }

  return [...items].sort((a, b) => {
    const r = rank(a.status) - rank(b.status)
    if (r !== 0) return r
    return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
  })
}
